import { DowngradeTypeBE, DowngradeTypeFE } from "types/tierSets";

export const downgradeOptions = [
  { id: "none", label: "none" },
  { id: "automatic", label: "automatic" },
  {
    id: "anniversaryRegistrationDate",
    label: "everyAnniversaryOfRegistrationDate",
    period: "registration_anniversary",
  },
  {
    id: "annualChosenDate",
    label: "annualRecalculationOnChosenDate",
    recalculationDates: [],
  },
  {
    id: "everyXMonths",
    label: "everyXMonthsAfterReachingCurrentTier",
    period: "recalculation_every_month_after_tier_promotion",
    interval: null,
  },
];

export const getDowngradeLabel = (downgrade: DowngradeTypeBE) => {
  switch (downgrade.mode) {
    case "none":
      return "none";
    case "automatic":
      return "automatic";
    case "periodic":
      if (downgrade.recalculationDates) {
        return "annualRecalculationOnChosenDate";
      } else if (downgrade.interval) {
        return "everyXMonthsAfterReachingCurrentTier";
      }

      return "everyAnniversaryOfRegistrationDate";
  }
};

export const formatDowngradeMode = (
  downgrade: DowngradeTypeFE,
): DowngradeTypeBE => {
  switch (downgrade.mode) {
    case "annualChosenDate":
      return {
        period: downgrade.period,
        mode: "periodic",
        recalculationDates: downgrade.recalculationDates,
      };
    case "anniversaryRegistrationDate":
      return {
        period: downgrade.period,
        mode: "periodic",
      };
    case "everyXMonths":
      return {
        period: downgrade.period,
        mode: "periodic",
        interval: downgrade.interval,
      };
    case "automatic":
    case "none":
    default:
      return { mode: downgrade.mode };
  }
};

export const parseDowngradeMode = (
  downgrade: DowngradeTypeBE,
): DowngradeTypeFE => {
  switch (downgrade.mode) {
    case "periodic":
      switch (downgrade.period) {
        case "registration_anniversary":
          return {
            ...downgrade,
            mode: "anniversaryRegistrationDate",
          };
        case "annual_recalculation_on_chosen_dates":
          return { ...downgrade, mode: "annualChosenDate" };
        case "recalculation_every_month_after_tier_promotion":
          return { ...downgrade, mode: "everyXMonths" };
        default: {
          return { mode: "none" };
        }
      }
    case "automatic":
    case "none":
    default:
      return { mode: downgrade.mode };
  }
};
